import { useTranslation } from 'react-i18next'

import { LockedButton } from '@/components/ui-kit/Buttons'
import { MascotBubble, MascotSlot } from '@/components/ui-kit/Mascot'
import { Headline } from '@/components/ui-kit/Primitives'
import { ScreenShell, TopBar } from '@/components/ui-kit/Shell'

/** Warteraum vor dem Start. */
export function LobbyScreen({ nickname, joinCode }: { nickname: string; joinCode: string }) {
    const { t } = useTranslation()

    return (
        <ScreenShell>
            <TopBar title={t('lobby.title')} right={joinCode} />

            <div className="flex flex-1 flex-col items-center justify-center gap-4 text-center">
                <div className="relative">
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_55%,rgb(255_138_26/0.2),transparent_65%)]" />
                    <MascotSlot pose="winking" size={180} />
                </div>

                <MascotBubble side="above">{t('lobby.bubble')}</MascotBubble>

                <Headline className="mt-2 text-2xl">{t('lobby.headline')}</Headline>
                <p className="max-w-[300px] text-sm text-wb-dim">{t('lobby.body')}</p>

                <p className="rounded-full bg-wb-panel-hi px-4 py-2 text-[13px] font-bold">
                    {t('lobby.youAre', { nickname })}
                </p>
            </div>

            <LockedButton>{t('common.waitingForTeacher')}</LockedButton>
        </ScreenShell>
    )
}
